// Action Types
export const AUTH_ACTIONS = {
  SET_LOADING: 'SET_AUTH_LOADING',
  SET_AUTHENTICATED: 'SET_AUTHENTICATED',
  CHECK_AUTH_START: 'CHECK_AUTH_START',
  CHECK_AUTH_SUCCESS: 'CHECK_AUTH_SUCCESS',
  CHECK_AUTH_FAILURE: 'CHECK_AUTH_FAILURE',
  LOGOUT: 'AUTH_LOGOUT'
}

// Action Creators
export const setAuthLoading = (isLoading) => ({
  type: AUTH_ACTIONS.SET_LOADING,
  payload: isLoading
})

export const setAuthenticated = (isAuthenticated) => ({
  type: AUTH_ACTIONS.SET_AUTHENTICATED,
  payload: isAuthenticated
})

export const checkAuthStart = () => ({
  type: AUTH_ACTIONS.CHECK_AUTH_START
})

export const checkAuthSuccess = (user, token) => ({
  type: AUTH_ACTIONS.CHECK_AUTH_SUCCESS,
  payload: { user, token }
})

export const checkAuthFailure = () => ({
  type: AUTH_ACTIONS.CHECK_AUTH_FAILURE
})

export const logout = () => ({
  type: AUTH_ACTIONS.LOGOUT
})

// Regular action creators (no thunks)
export const logoutUser = () => ({
  type: AUTH_ACTIONS.LOGOUT
})
